import styles from "../../../styles/styles";
import moment from "moment-timezone";
import * as config from "../../../config.json";

const IndividualCommentFooter = (props) => {
  const { createdAt, commentCreatedBy } = props;
  const formattedDate = moment(createdAt).tz(config.timezone).toLocaleString();

  return (
    <div style={styles.cardFooter}>
      {formattedDate} ({commentCreatedBy})
    </div>
  );
};

export default IndividualCommentFooter;
